import { render, staticRenderFns } from "./PromotionIndex.vue?vue&type=template&id=0171548f&scoped=true"
import script from "./PromotionIndex.vue?vue&type=script&lang=js"
export * from "./PromotionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171548f",
  null
  
)

export default component.exports